const NotFound = () => {
  return (
    <section className="container flex h-[calc(100vh-128px)] w-full flex-col-reverse items-center justify-evenly  md:flex-row md:justify-around">
      <p className="text-2xl text-orange"> 페이지가 존재하지 않습니다.</p>
    </section>
  );
};

export default NotFound;
